<div cdkTrapFocus class="creation-modal-wrapper">
  <div>
    <button id="close-modal-cross-btn" type="button" class="close pull-right btn-close-modal" aria-label="Close"
            (click)="cancelModal()"
            (keydown.enter)="cancelModal()">
      <span id="close-modal-x" class= "close-modal-x" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-header">
    <label i18n="Select from available roles Title|Title of select roles@@selectRolesTitle" class="modal-header-title">Select from available roles</label>
    <label i18n="Available roles|Available roles@@availableRolesAndAreas" class="modal-header-subtitle">Available choices</label>
  </div>

  <div class="modal-body">
    <ul id="rolesSelectionList" role="listbox"  class="col-md-8" #rolesSelectionList>
      <li tabindex="0" role="option" aria-checked="false">
        <input type="checkbox" tabindex="-1" [checked]="allChecked" class="roles text-area" rows="6"
               name="accountCreationRolesTextArea" id="roles-select-all" (change)="toggleSelectAllRolesOnPage()">
        <span i18n="Select all roles Option|Select all roles Option@@selectAllRolesAndAreasOption" class="form-check-label"
               for="roles-select-all"> Select all</span>
      </li>
      <li class="form-check" tabindex="-1" role="option" *ngFor="let role of fixedRoles; let i = index">
        <input class="form-check-input" tabindex="-1" rows= "6" [checked]="role.checked" (change)="onChange(role, $event.target)" name="{{'role' + i}}"
               type="checkbox" id="{{'role' + i}}" #rolesCheckbox >
        <span for="{{'role' + i}}" class="form-check-label">
          {{role.role}}
        </span>
      </li>
    </ul>
  </div>
  <div class="modal-buttons">
   <button i18n="Cancel button Title|Title for Cancel button@@cancelButton" class="modal-button cancel" id="cancel"
          (click)="cancelModal()" type="button">Cancel
   </button>
   <button i18n="Done button Title|Title for Done button@@doneButton" class="modal-button done"
          (click)="doneModal()" type="button">Done
   </button>
  </div>
</div>
